export default {
	themes: {
		light: 'Light',
		dark: 'Dark'
	}
};
